import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ChainAuditService {
    private apiUrl = `${environment.apiHost}/location`;

    constructor(private http: HttpClient, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {
    }

    async getChainAudit() {
        return this.http.get(`${this.apiUrl}/all-audits`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for chain audit timed out!"))
            );
    }

}